import * as React from 'react';

export class ThumbnailsLabel extends React.PureComponent {
  render() {
    return <div className="thumbnailslayer-label-container aligned">Thumbnails</div>;
  }
}
